import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addTransformationsToCloudinary } from '~/Helpers/Url.helpers';
import { useNavigation, useProvider } from '~/Hooks';
import { selectBookedListLength } from '~/store/bookings';
import { selectEventGroup } from '~/store/eventGroups';
import { selectEventById } from '~/store/events';
import {
  requestProviderLocationsList,
  requestProviderTrainerList,
  selectLocationList,
  selectTrainersById,
} from '~/store/provider';

export const useEventPageInformation = () => {
  // hooks
  const dispatch = useDispatch();
  const { getParams } = useNavigation();
  const { id } = getParams();
  const { currentProvider } = useProvider();

  // selectors
  const selectedEvent = useSelector(selectEventById(id || ''));
  const eventGroup = useSelector(selectEventGroup(selectedEvent?.eventGroupId || ''));
  const locations = useSelector(selectLocationList);
  const trainers = useSelector(selectTrainersById(selectedEvent?.trainerIds ?? []));
  const totalBookings = useSelector(selectBookedListLength);

  // actions
  const loadLocations = bindActionCreators(requestProviderLocationsList, dispatch);
  const loadTrainers = bindActionCreators(requestProviderTrainerList, dispatch);

  // const
  const eventLocation = locations.find((loc) => loc.uuid === selectedEvent?.locationId ?? '');

  const trainerString = trainers.reduce((str, trainer) => {
    if (selectedEvent.trainerIds.includes(trainer.trainerId)) {
      if (str.length === 0) {
        return trainer.firstName;
      }
      return `${str}, ${trainer.firstName}`;
    }
    return str;
  }, '');

  const eventImage = addTransformationsToCloudinary(eventGroup?.imageUrl ?? '', [
    'fl_lossy',
    'f_auto',
  ]);

  //Loads locations and trainers if none have been found
  useEffect(() => {
    if (locations.length === 0) {
      loadLocations(currentProvider?.uuid || '');
    }

    if (trainers.length === 0) {
      loadTrainers(currentProvider?.uuid || '');
    }
  }, []);

  return {
    eventImage,
    eventName: selectedEvent?.name,
    trainerString,
    locationName: eventLocation?.name || '',
    totalBookings,
    totalSeats: selectedEvent?.seats,
    cancelled: selectedEvent?.cancelled,
  };
};
